module.exports = __webpack_public_path__ + "static/img/icon_out.ec21acc5.svg";